<template lang="pug">
nav.v-mobile-nav-bar.mobile-nav-bar(v-if="data" )
	ul.mobile-nav-bar__list(v-if="data.links" )
		li.mobile-nav-bar__item(v-for="(link, index) in data.links" :key="index" :class="{'active': link.active}")
			a.mobile-nav-bar__link(v-if="link.link" :href="link.link")
				v-svg-icon.mobile-nav-bar__icon(v-if="link.icon" :icon="link.icon")
				.mobile-nav-bar__text(v-if="link.text" ) {{ link.text }}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},



	}
};
</script>
